import React, { useState } from "react";
import editClasses from "./EditCampaign.module.css";
import { urlifyName } from "../../shared/Utils/PageUrl";
import { QRCodeCanvas } from "qrcode.react";

// This is the Share component in the Edit Campaign modal

const CampaignShareBox = ({ campaignData }) => {
  const [copied, setCopied] = useState(false);
  const campaignUrl = campaignData
    ? campaignData.campaign_type === "animal"
      ? `https://sponsorapet.org/campaigns/animal/${urlifyName(
          campaignData.nonprofit_name
        )}/${urlifyName(campaignData.animal_name)}/${campaignData.id}`
      : `https://sponsorapet.org/campaigns/${campaignData.campaign_type}/${urlifyName(
          campaignData.nonprofit_name
        )}/${urlifyName(campaignData.campaign_title)}/${campaignData.id}`
    : "";

  const downloadQRCode = () => {
    const canvas = document.getElementById("qrcode");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "CampaignQRCode.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(campaignUrl).then(
      () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2500);
      },
      (err) => {
        console.error("Could not copy text: ", err);
      }
    );
  };

  // Function to open Facebook share dialog
  const shareToFb = () => {
    const facebookUrl = `https://www.facebook.com/dialog/share?app_id=952019939706310&display=popup&href=${encodeURIComponent(
      campaignUrl
    )}&redirect_uri=https%3A%2F%2Fdevelopers.facebook.com%2Ftools%2Fexplorer`;
    window.open(facebookUrl, "_blank");
  };

  // Function to open Twitter share dialog
  const shareToX = () => {
    const text = `Check out our newest Animal Campaign at`;
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      text
    )}&url=${encodeURIComponent(campaignUrl)}`;
    window.open(twitterUrl, "_blank");
  };
  return (
    <div
      className={`${editClasses.qrcode_box} flex flex-col justify-center items-center border border-gray-200 rounded-3xl shadow-sm shadow-gray-200`}
    >
      <h2 className="text-2xl font-normal mb-4">Share</h2>
      <QRCodeCanvas
        id="qrcode"
        value={campaignUrl}
        size={195}
        level={"H"}
        style={{ margin: "0 auto" }}
      />
      <button onClick={downloadQRCode} className="mt-6 w-52 py-2.5 rounded-full bg-blue text-gray-900 !font-bold text-sm">
        Download QR Code
      </button>
      <button onClick={copyToClipboard} className="mt-3 w-52 py-2.5 rounded-full bg-orange text-gray-900 !font-bold text-sm">
        Copy Campaign Link
      </button>
      {copied && <p className="text-green-500 text-xs mt-1">url copied</p>}
      <button onClick={shareToX} className="mt-3 w-52 py-2.5 rounded-full bg-blue-navy text-white !font-bold text-sm">
        Share to Twitter
      </button>
      <button onClick={shareToFb} className="mt-3 w-52 py-2.5 rounded-full bg-white border border-gray-300 text-gray-900 !font-bold text-sm">
        Share to Facebook
      </button>
    </div>
  );
};

export default CampaignShareBox;
